/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { ZoomVideoProvider } from './providers/zoomVideoProvider';
import { TwilioVideoProvider } from './providers/twilioVideoProvider';
import { VideoProviderName, VideoProviderType } from './types';

export const videoProviderFactory = (provider: VideoProviderName | string): VideoProviderType => {
  switch (provider) {
    case VideoProviderName.ZOOM:
      return new ZoomVideoProvider();
    case VideoProviderName.TWILIO:
    default:
      return new TwilioVideoProvider();
  }
};
